import { render, staticRenderFns } from "./ToastsTarget.vue?vue&type=template&id=2639ec44&"
import script from "./ToastsTarget.vue?vue&type=script&lang=js&"
export * from "./ToastsTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports